import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { WeatherStation } from 'types';

export const getWeatherStation = async (
  stationId: number | undefined
): Promise<WeatherStation | undefined> => {
  if (stationId === undefined || stationId < 1) return;
  const { data } = await axios.get(`/api/weather/stations/${stationId}`);
  return data as WeatherStation;
};

type QueryFnType = typeof getWeatherStation;

type UseWeatherStationOptions = {
  stationId: number | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useWeatherStation = ({
  stationId,
  config,
}: UseWeatherStationOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['weatherStations', stationId],
    queryFn: () => getWeatherStation(stationId),
  });
};
